import Joi from 'joi';

export const EditMagazineArticlePageTitleSchema = Joi.object({
  title: Joi.string().required().messages({ 'string.empty': 'Required!' }),
  // pagePath: Joi.string().required().messages({ "string.empty": "Required!" }),
});
